<app-template-number [disabled]="disabled" [characters]="characters" [value]="value" [control]="control" [required]="required" [label]="label" />
